import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
//Types
import type { ActionJob, LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

export const getCuryLocalActions = (
	action: ActionJob,
	localControlOptions: LocalControlOptions[],
): LocalControlOptions[] => {
	const $format = get(format);
	localControlOptions = [
		{
			title: $format('label_control_cury', {
				default: 'Control Cury',
			}),
			value: 'cury.set',
			attr: {
				intensity: action.params?.intensity != null,
				slot: true,
			},
			params: {
				id: 0,
				on: action.params?.on || false,
				intensity: action.params?.intensity ?? 50,
				slot: action.params?.slot || 'left',
			},
			onOffState: {
				toggle_after_disabled: true,
				checked: action.params?.on != undefined,
				selectBox: true,
				label: $format('label_set_state_property', {
					default: 'Set State property',
				}),
			},
		},
		{
			title: $format('action_to_label_start_boost', {
				default: 'Start boost',
			}),
			value: 'cury.boost',
			attr: {
				slot: true,
			},
			params: {
				id: 0,
				slot: action.params?.slot || 'left',
			},
		},
		{
			title: $format('label_control_ambient_light', {
				default: 'Control ambient light',
			}),
			value: 'cury.setconfig',
			attr: {
				config: {
					ambient: {
						brightness: action.params?.config?.ambient?.brightness != null,
						color: action.params?.config?.ambient?.color != null,
						enable: action.params?.config?.ambient?.enable != null,
						use_vial_color: action.params?.config?.ambient?.use_vial_color != null,
					},
				},
			},
			params: {
				id: 0,
				config: {
					ambient: {
						brightness: action.params?.config?.ambient?.brightness ?? 50,
						color: action.params?.config?.ambient?.color || [255, 0, 0],
						enable: action.params?.config?.ambient?.enable || false,
						use_vial_color: action.params?.config?.ambient?.use_vial_color || false,
					},
				},
			},
		},
	];
	return localControlOptions;
};

export const getCurySlotOptions = () => {
	const $format = get(format);
	return [
		{
			title: $format('label_intensity_left', {
				default: 'Intensity left',
			}),
			value: 'left',
		},
		{
			title: $format('label_intensity_right', {
				default: 'Intensity right',
			}),
			value: 'right',
		},
	];
};
